import { SimpleGrid, Stack, Text } from "@chakra-ui/react";
import type { SimpleGridProps } from "@chakra-ui/react";
import type { ReactNode } from "react";

interface Row {
  label: string;
  value: ReactNode;
}

export const LabelValueGrid = ({
  rows,
  columns = { base: 1, sm: 2 },
}: {
  rows: Row[];
  columns?: SimpleGridProps["columns"];
}) => (
  <SimpleGrid columns={columns} spacingX="6" spacingY="4">
    {rows.map((row, index) => (
      <Stack key={`${row.label}-${index}`} spacing="1">
        <Text color="smMuted" fontSize="xs" fontWeight="semibold" textTransform="uppercase" letterSpacing="wide">
          {row.label}
        </Text>
        <Text as="div" color="smText" fontSize="sm">
          {row.value}
        </Text>
      </Stack>
    ))}
  </SimpleGrid>
);
